var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShape1Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 60,
    viewBox: "0 0 278 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M174.931 184a119.422 119.422 0 01-28.896-3.784c-33.228-8.322-68.698-29.862-97.321-59.068-20.104-20.526-34.835-42.834-42.6-64.511C2.055 45.309 0 34.338 0 24.034 0 6.699 3.172-5.398 9.696-12.936 16.318-20.573 26.5-24 42.719-24c9.875 0 21 1.18 33.88 2.546 15.746 1.664 33.59 3.559 52.901 3.559 3.505 0 7.189-.064 10.945-.191 14.757-.495 29.071-1.856 42.898-3.173 14.804-1.41 28.79-2.741 41.142-2.741 21.229 0 34.439 4.029 42.855 13.056C274.525-3.209 278 8.231 278 24.033a285.87 285.87 0 01-3.961 47.79c-5.373 31.648-15.9 58.426-30.444 77.444C225.981 172.305 202.876 184 174.931 184z",
    fill: "url(#shape-1_inline_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-1_inline_svg__paint0_linear",
    x1: 0,
    y1: -24,
    x2: 299.477,
    y2: 146.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

export default SvgShape1Inline;